import {authHeader} from '../_helpers'
import axios from 'axios'

export const customerService = {
  searchCustomers,
  createCustomer,
  getCustomer,
  updateCustomer,
  deleteCustomer
}

function createCustomer (customer) {
  return axios.post(process.env.BASE_URL + '/api/customer', customer, {headers: authHeader()})
}

function getCustomer (customerId) {
  return axios.get(process.env.BASE_URL + '/api/customer/' + customerId, {headers: authHeader()})
}

function updateCustomer (customer) {
  return axios.put(process.env.BASE_URL + '/api/customer/' + customer.id, customer, {headers: authHeader()})
}

function deleteCustomer (customerId) {
  return axios.delete(process.env.BASE_URL + '/api/customer/' + customerId, {headers: authHeader()})
}

function searchCustomers (searchTerms, page, size) {
  if (page !== undefined && size !== undefined) {
    return axios.post(process.env.BASE_URL + '/api/customer/search?page=' + page + '&size=' + size, searchTerms, {headers: authHeader()})
  } else {
    return axios.post(process.env.BASE_URL + '/api/customer/search', searchTerms, {headers: authHeader()})
  }
}



// WEBPACK FOOTER //
// ./src/_services/customer-service.js